export default __webpack_public_path__ + "static/media/rocket_anim_41.5cfe242e.png";